import { render, staticRenderFns } from "./EditSalesInvoicePage.vue?vue&type=template&id=0066b95c"
import script from "./EditSalesInvoicePage.vue?vue&type=script&lang=js"
export * from "./EditSalesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports